module.exports = __webpack_public_path__ + "static/media/cross_white.38f8f367.svg";